import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Use `TrackUsageContextStandalone` instead.
 */
export const TrackUsageContext = /*#__PURE__*/createContext(() => {});

/**
 * @deprecated Use `useTrackUsageContextStandalone` instead.
 */
export const useTrackUsageContext = () => useContext(TrackUsageContext);
const MOCK_TRACKER = {
  track: () => {},
  getConfig: () => ({}),
  setProperties: () => {},
  clone: () => MOCK_TRACKER
};

/**
 * @deprecated Use `TrackUsageProvider` instead and pass in the tracker from the app.
 */
export const usageTrackerAdapter = tracker => config => tracker.track(config.key, config.properties);

/**
 * Tracking for standalone events. This requires events to be created in the Usage Library.
 * See migration guide https://product.hubteam.com/docs/usage-tracking-manual/docs/guides/migrating-from-events-yaml.html
 */

const TrackUsageContextStandalone = /*#__PURE__*/createContext(MOCK_TRACKER.clone({
  standalone: true
}).track);
export const useTrackUsageContextStandalone = () => {
  const tracker = useContext(TrackUsageContextStandalone);
  if (!tracker) {
    throw new Error('TrackUsageContextStandalone not found');
  }
  return tracker;
};
export const TrackUsageProvider = ({
  children,
  tracker: maybeTracker
}) => {
  const tracker = maybeTracker || MOCK_TRACKER;
  const track = useMemo(() => usageTrackerAdapter(tracker), [tracker]);
  const trackStandalone = useMemo(() => tracker.clone({
    standalone: true
  }).track, [tracker]);
  return (
    /*#__PURE__*/
    // TODO: remove deprecated tracking when migration to standalone is complete
    _jsx(TrackUsageContext.Provider, {
      value: track,
      children: /*#__PURE__*/_jsx(TrackUsageContextStandalone.Provider, {
        value: trackStandalone,
        children: children
      })
    })
  );
};
TrackUsageProvider.displayName = 'TrackUsageProvider';